import type { $Fetch } from 'ofetch';
import type { CadenciaGateway, ListCadenciasParams } from '@/application/port/out/CadenciaGateway';
import type { CadenciaConfig, UpsertCadenciaConfigCommand } from '@/domain/model/CadenciaConfig';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/commerce/cadencias';

/** HTTP gateway de Cadências. Authority BE: `commerce:cadencia:read|manage`. */
export class HttpCadenciaGateway implements CadenciaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListCadenciasParams): Promise<Page<CadenciaConfig>> {
    const res = await this.client<ApiResponse<Page<CadenciaConfig>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertCadenciaConfigCommand): Promise<CadenciaConfig> {
    const res = await this.client<ApiResponse<CadenciaConfig>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertCadenciaConfigCommand): Promise<CadenciaConfig> {
    const res = await this.client<ApiResponse<CadenciaConfig>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async remove(id: string): Promise<void> {
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
